import React , {useState} from 'react'
import {Container} from "reactstrap"
import {useHistory} from "react-router-dom"
import "./enteral.css";
import Header from "./Header"
import Footer from "./Footer"

function Enteral() {

    const [weight, setWeight] = useState("");
    const [state,setState] = useState({
        isWeight : false,
    })

    const [FR, setFR] = useState("")
    const [FF, setFF] = useState("")

    let history = useHistory();

    const feedingrate = () => {
        history.push("/feeding-rate")
    }

    const feedingfreq = () => {
        history.push("/feeding-frequency")
    }

    const handleWeight = (event) => {
        setState({ isWeight: event.target.value });
        setWeight(event.target.value);
        localStorage.setItem("current weight", event.target.value);
      };

    const handleFR = (event) => {
        setFR(event.target.value)
        localStorage.setItem("Feeding Rate", event.target.value)
    }

    const handleFF = (event) => {
        setFF(event.target.value)
        localStorage.setItem("Feeding Frequency", event.target.value)
    }


    return (
        <div className="row">
        <div className="col-md-12">
        <div className="enteral__page">
        <Header/>
        <div className="enteral__content">
            <div className ="header__topic">
                <h4>Enteral Nutrition</h4>
            </div>
                <p>Please insert information into the cells.</p>
                <span>Current Weight</span>
                <input className = "input__weight"
                 name="weight" type = "number"  pattern = "^(\d*\.)?\d+$" size="7" maxLength="6" placeholder = "0.000" onSubmit = {state.isWeight} onChange = {handleWeight}
                 value = {weight}/>
        <div className = "weight__exist">
                {state.isWeight ?(
                        <div>
                            <p><strong>Select method of calculation:</strong></p>
                            <button onChange={handleFR} value = {FR} className = "feedingrate_button" onClick = {feedingrate}>
                                Feeding Rate
                                </button>
                            <button onChange={handleFF} value = {FF} className = "feedingfreq_button" onClick = {feedingfreq}>Feed Frequency</button>
                        </div>    
                    ) : (
                        <div>
                            
                        </div>
                    )}
                </div>
                </div>
        </div> 
        </div>
        </div>
    )
}

export default Enteral
